import { Component, ElementRef, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { first } from 'rxjs/operators';
import { AuthenticationService } from 'src/app/core/services/auth.service';
import { AuthfakeauthenticationService } from 'src/app/core/services/authfake.service';
import { EventService } from 'src/app/core/services/event.service';
import { ApiService } from 'src/app/shared/services/api.service';
import { environment } from 'src/environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { HttpClient, HttpHeaders } from '@angular/common/http';
declare var $: any;
import * as bootstrap from 'bootstrap'; // Import Bootstrap

interface Product {
  name: string;
  quantity: number;
  src: string;
}
@Component({
  selector: 'app-web-landing-page',
  templateUrl: './web-landing-page.component.html',
  styleUrls: ['./web-landing-page.component.scss']
})
export class WebLandingPageComponent implements OnInit {
  @ViewChildren('navLinks') navLinks: QueryList<ElementRef>;

  panelOpenState = false
  listProvices
  phone
  fullName
  listProvince
  note
  formData!: FormGroup;
  products: Product[] = [
    { name: 'wifi', quantity: 1, src: 'assets/images/loa_wifi.png' },
    { name: '4g', quantity: 1, src: 'assets/images/loa_4g.png' }
  ];
  isMobile
  currentMonth
  constructor(
    private authService: AuthenticationService,
    private formBuilder: FormBuilder,
    private http: HttpClient,
    private route: ActivatedRoute,
    private router: Router,
    private eventService: EventService,
    private apiService: ApiService,
    private translateService: TranslateService,
    public authenticationService: AuthenticationService,
    public authFackservice: AuthfakeauthenticationService,
    private modalService: NgbModal,
  ) { 
    const now = new Date();
    const monthNames = [
      "Tháng 01",
      "Tháng 02",
      "Tháng 03",
      "Tháng 04",
      "Tháng 05",
      "Tháng 06",
      "Tháng 07",
      "Tháng 08",
      "Tháng 09",
      "Tháng 10",
      "Tháng 11",
      "Tháng 12",
    ];
    this.currentMonth = monthNames[now.getMonth()];}
  @ViewChild('chooseModal') chooseModal: any;
  @ViewChild('searchModal') searchModal: any;
  listDataSearch: any[] = []
  pageSize = 999
  pageIndex = 1
  totalCount = 0
  productLocal
  ngOnInit(): void {
    this.productLocal = JSON.parse(localStorage.getItem('selectedProduct'))

    this.getProvinces()
    this.setActiveProduct(this.products[0])
    this.fetchData()
    this.formData = this.formBuilder.group({
      fullName: ['', [Validators.required]], // Họ và tên
      phone: ['', [Validators.required, Validators.pattern('^[0-9]{10,11}$')]], // Số điện thoại
      provines: ['', Validators.required], // Tỉnh thành
      note: ['', Validators.required] // Lời nhắn
    });
    this.checkUserDevice();
  }
  ngAfterViewInit() {
    window.addEventListener('scroll', this.handleScroll.bind(this));
    this.addSmoothScrollToNavLinks();

  }

  handleScroll() {
    const sections = document.querySelectorAll('section');
    const navLinks = this.navLinks.toArray().map(link => link.nativeElement);

    let activeIndex = -1;
    let maxScrollTop = 0;

    sections.forEach((section, index) => {
      const sectionTop = section.offsetTop;
      const sectionHeight = section.clientHeight;

      if (window.pageYOffset >= sectionTop - sectionHeight / 3) {
        if (window.pageYOffset >= maxScrollTop) {
          maxScrollTop = window.pageYOffset;
          activeIndex = index;
        }
      }
    });

    navLinks.forEach((link, index) => {
      link.classList.remove('active');
      if (index === activeIndex) {
        link.classList.add('active');
      }
    });
  }
  addSmoothScrollToNavLinks() {
    this.navLinks.forEach(link => {
      link.nativeElement.addEventListener('click', (event: Event) => {
        event.preventDefault();
        const targetId = (event.target as HTMLElement).getAttribute('href');
        const targetElement = document.querySelector(targetId);
        if (targetElement) {
          targetElement.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }
      });
    });
  }
  checkUserDevice(): void {
    this.isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    if (this.isMobile) {
      console.log('User is on a mobile device');
    } else {
      console.log('User is on a desktop/laptop computer');
    }
  }

  fetchData() {
    const name = this.selectedProduct.name ? this.selectedProduct.name : JSON.parse(localStorage.getItem('selectedProduct'))?.name
    this.apiService.getList('service-package?device_name=' + name
    ).subscribe({
      next: (res) => {
        this.packages = res['metadata']['packages'] ? res['metadata']['packages'] : [];
      }
    })

  }
  isPlaying = false;
  audio = new Audio('assets/audio/File_test.mp3');
  playAudio() {
    if (this.isPlaying) {
      this.audio.pause();
      this.isPlaying = false;
    } else {
      this.audio.play();
      this.isPlaying = true;
      this.audio.onended = () => {
        this.isPlaying = false;
      };
    }
  }
  selectedProduct: { name: string; quantity: number, src: any } | null = null;
  quantities: { [key: string]: number } = {
    'wifi': 1,
    '4g': 1,
  };
  selectProduct(product: any) {
    this.selectedProduct = product;
    $('#chooseDetails').modal('show'); // Hiện modal bằng jQuery
  }
  activeProduct: Product | null = this.products.find(product => product.name === 'wifi') || null;
  isFirstCall = true;

  setActiveProduct(product: Product): void {
    if (this.isFirstCall) {
      this.activeProduct = product;
      this.selectedProduct = {
        name: product.name,
        quantity: this.productLocal?.quantity,
        src: product.src
      };
      this.isFirstCall = false;

    } else {
      this.activeProduct = product;
      this.selectedProduct = {
        name: product.name,
        quantity: this.quantities[product.name],
        src: product.src
      };
    }
    this.fetchData()
    this.selectedPackageId = product.name === '4g' ? 5 : 2;
  }

  changeQuantity(product: Product, change: number): void {
    const newQuantity = this.quantities[product.name] + change;
    if (newQuantity > 0) {
      this.quantities[product.name] = newQuantity;
      if (this.activeProduct?.name === product.name) {
        this.selectedProduct.quantity = newQuantity;
      }
    }
  }
  selectedPackage: number | null = null;
  packages
  selectedPackageId: number | null = 2;
  selectPackage(packageId: number) {
    if (this.selectedPackageId === packageId) {
      this.selectedPackageId = null;
    } else {
      this.selectedPackageId = packageId;
    }
  }
  onCheckboxChange(event: Event) {
    const checkbox = event.target as HTMLInputElement;
    if (!checkbox.checked) {
      checkbox.checked = true;
    }
  }
  openLink(): void {
    this.checkUserDevice();
    if (this.isMobile) {
      window.location.href = 'mbbank://?ad_dp=marketplaceapp&code=PHZTOMOTEK';
    }
    else {
      const modalElement = this.chooseModal.nativeElement;
      const modal = new bootstrap.Modal(modalElement);
      modal.show();
    }
  }
  openSearch(): void {
    this.formData = this.formBuilder.group({
      fullName: ['', [Validators.required]],
      note: ['', Validators.required]
    });
    const modalElement = this.searchModal.nativeElement;
    const modal = new bootstrap.Modal(modalElement);
    modal.show();
  }
  saveToLocalStorage(): void {
    if (this.selectedProduct) {
      localStorage.setItem('selectedProduct', JSON.stringify(this.selectedProduct));
    } else {
      console.log("No product selected.");
    }
  }
  viewDetailsViettel(){
    const url = `https://viettelpost.com.vn/tra-cuu-hanh-trinh-don/`; 
    window.open(url, '_blank');
  }
  getProvinces() {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Token': '6def0d20-904c-11ef-8c65-92e564d0a60d'
    });
    this.http.get("https://online-gateway.ghn.vn/shiip/public-api/master-data/province", { headers })
      .subscribe((response: any) => {
        this.listProvince = response.data.reverse();
      });

  }
  handleOffline() {
    localStorage.setItem('serviceType', 'direct')
    this.router.navigate(['/account/web-form-page']).then(() => {
      document.querySelector('.modal-backdrop')?.remove();
      document.body.classList.remove('modal-open');
      document.body.style.overflow = '';
    });

  }

  handleOnline() {
    localStorage.setItem('serviceType', 'shipper')
    this.router.navigate(['/account/web-form-page']).then(() => {
      document.querySelector('.modal-backdrop')?.remove();
      document.body.classList.remove('modal-open');
      document.body.style.overflow = '';
    });
  }
  viewDetails(data) {
    const orderCode = data.order_code;
    // const url = `https://tracking.ghn.dev/?order_code=${orderCode}`; --dev
    const url = `https://donhang.ghn.vn/?order_code=${orderCode}`; //prod
    window.open(url, '_blank');
  } 
  saveData() {
    const data = {
      phone: this.formData.value.phone,
      full_name: this.formData.value.fullName,
      feedback: this.formData.value.note,
      province: this.formData.value.provines,
    }
    this.apiService.addItem('customer-feedback', data).subscribe({
      next: res => {
        this.apiService.showToast(this.translateService.instant('Thành công'), this.translateService.instant('Đăng ký thành công'), 'success')
        this.eventService.setLoading(false)
        this.modalService.dismissAll()
      },
      error: e => {
        this.apiService.showToast(this.translateService.instant('FORM.Error'), this.translateService.instant('FORM.ErrorMessageAdd'), 'error')
        this.eventService.setLoading(false)
      }
    })
  }
  flagHide = false
  searchOrders() {
    this.apiService.getList('public/customer-orders?bankAccountName=' + this.formData.value.fullName +
      '&text=' + this.formData.value.note).subscribe({
        next: res => {
          console.log(res);
          this.listDataSearch = res.metadata.listOrder
          console.log(this.listDataSearch);

          if (res.metadata.listOrder.length == 0) {
            this.flagHide = true
          }
          else {
            this.flagHide = false
          }
        },
        error: e => {
          if (e) {
            this.apiService.showToast(this.translateService.instant('FORM.Error'), this.translateService.instant(e), 'error')
          }
        }
      })
  }
}
